<template>
  <v-chip
    small
    class="font-weight-bold overline"
    :color="templateType.color"
    text-color="white"
    >{{ templateType.name }}</v-chip
  >
</template>

<script>
export default {
  props: {
    templateType: { type: Object, required: true },
  },
}
</script>
